"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class SubscriptionServiceLive {
    async getSubscriptionSettings(companyId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/subscription-settings`);
        return response.data;
    }
    async updateSubscriptionSettings(companyId, settings) {
        const response = await HttpProvider_1.httpProvider.put(`/company/${companyId}/subscription-settings`, settings);
        return response.data;
    }
    async createSubscription(companyId, shareholderId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholders/${shareholderId}/subscriptions`, body);
        return response.data;
    }
    async cancelSubscription(companyId, shareholderId, subscriptionId, txHash) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholders/${shareholderId}/subscriptions/${subscriptionId}/cancel`, txHash ? { txHash } : {});
        return response.data;
    }
    async recordSubscriptionVaultTransaction(companyId, shareholderId, subscriptionId, txHash) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholders/${shareholderId}/subscriptions/${subscriptionId}/vault-transactions`, { txHash });
        return response.data;
    }
    async getShareholderSubscriptions(companyId, shareholderId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/shareholders/${shareholderId}/subscriptions`);
        return response.data;
    }
    async getSubscriptions(companyId, query = {}) {
        // HttpProvider.get sends its second argument as the request body, which axios omits for GET, so
        // query params must be encoded into the URL.
        const search = new URLSearchParams();
        if (query.filter) {
            search.set("filter", query.filter);
        }
        if (query.q) {
            search.set("q", query.q);
        }
        if (query.shareholderId) {
            search.set("shareholderId", query.shareholderId);
        }
        const queryString = search.toString();
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/subscriptions${queryString ? `?${queryString}` : ""}`);
        return response.data;
    }
    async getSubscriptionDetail(companyId, subscriptionId) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/subscriptions/${subscriptionId}`);
        return response.data;
    }
    async acceptSubscription(companyId, subscriptionId, body = {}) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/subscriptions/${subscriptionId}/accept`, body);
        return response.data;
    }
    async rejectSubscription(companyId, subscriptionId, body) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/subscriptions/${subscriptionId}/reject`, body);
        return response.data;
    }
    async approveSubscription(companyId, subscriptionId, body = {}) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/subscriptions/${subscriptionId}/approve`, body);
        return response.data;
    }
    async issueSubscription(companyId, subscriptionId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/subscriptions/${subscriptionId}/issue`, {});
        return response.data;
    }
    async approveDealingWindow(companyId, windowKey, body = {}) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/subscriptions/window/${encodeURIComponent(windowKey)}/approve`, body);
        return response.data;
    }
    async declareSubscriptionPayment(companyId, shareholderId, subscriptionId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/shareholders/${shareholderId}/subscriptions/${subscriptionId}/payment-declared`, {});
        return response.data;
    }
    async reconcileSubscriptionPayment(companyId, subscriptionId) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/subscriptions/${subscriptionId}/payment-reconciled`, {});
        return response.data;
    }
    async getAllotmentRun(companyId, windowKey) {
        const response = await HttpProvider_1.httpProvider.get(`/company/${companyId}/subscriptions/window/${encodeURIComponent(windowKey)}/allotment-run`);
        return response.data;
    }
    async completeAllotmentRun(companyId, windowKey) {
        const response = await HttpProvider_1.httpProvider.post(`/company/${companyId}/subscriptions/window/${encodeURIComponent(windowKey)}/issue`, {});
        return response.data;
    }
}
exports.SubscriptionServiceLive = SubscriptionServiceLive;
//# sourceMappingURL=SubscriptionServiceLive.js.map